import { z } from 'zod/v4'
import { idSchema } from '@/lib/utils'

/** The edit screen names the draft cart that holds a change to the order. */
export const salesOrderEditSearchSchema = z.object({
  cartId: idSchema('cart', true),
})
